import React from 'react'
import Grid from '@mui/material/Grid'
import AnDateTimePicker from '../../../../components/DateTime/DateTimePicker'
import moment from 'moment'

const IncidentDate = ({ formValues, handleChange }) => (
  <Grid item xs={12} md={6} lg={3}>
    <AnDateTimePicker
      name="incidentDate"
      label="Incident Date"
      date={formValues.incident.incidentDate}
      disableFuture
      disabled={!!formValues?.incident?.cadIncident}
      maxDateTime={moment()}
      onChange={(newDate) =>
        handleChange({
          moduleName: 'incident',
          field: 'incidentDate',
          value: moment(newDate).isAfter(moment())
            ? moment().toISOString()
            : newDate,
        })
      }
      fullWidth
    />
  </Grid>
)

export default IncidentDate
